// extracted by mini-css-extract-plugin
export default {"servicetitle":"Services_servicetitle__bKrUz","serviceDescription":"Services_serviceDescription__wbyzo"};